import { ExpandMore } from '@material-ui/icons';
import styles from './styles';
import { withStyles } from '@material-ui/core';

//@ts-ignore
export default withStyles(styles)(ExpandMore);
